import { priceFromCost } from "@acc/shared"
import { clampParam } from "@acc/shared"
import { PriceType } from "../../../app/reducers/settingsReducer"

/**
 * Калькулятор цены WB — вариант default1 (фронт).
 *
 * Делегирует математику движку priceFromCost из @acc/shared, адаптируя интерфейс:
 *   - вход: PriceType (sale в процентах, напр. 2 = 2%)
 *   - выход: {price, old_price} где price = без скидки, old_price = со скидкой
 *
 * Конфиг комиссий: nalogInKassa=false (NALOG в знаменателе вместе с KOEF),
 * denominatorFees=[KOEF, NALOG], additives=[LOGISTIC].
 */
export const defaultCalcPrice = (
  props: PriceType & {
    price?: number
  },
): { price: number; old_price: number } => {
  const {
    sale = 0,
    price = 0,
    margin = 0,
    profit = 0,
    logistic = 0,
    ff = 0,
    coef = 0,
    tax = 0,
  } = props
  // На фронте нет MIN_CALC_PARAMS — нижняя граница 0.
  const currentPrice = priceFromCost(
    {
      price,
      margin: clampParam(margin, 0),
      minProfit: clampParam(profit, 0),
      ff: clampParam(ff, 0),
      nalog: clampParam(tax, 0),
      sale: Math.max(sale, 0) / 100, // проценты → доля
      // currentPrice считаем без скидки (withSale=false), old_price — со скидкой ниже.
      withSale: false,
    },
    {
      nalogInKassa: false,
      denominatorFees: [clampParam(coef, 0), clampParam(tax, 0)],
      additives: [clampParam(logistic, 0)],
    },
  )
  const SALE = Math.max(sale, 0) / 100
  return {
    price: currentPrice,
    old_price: Math.ceil(currentPrice / (1 - SALE)),
  }
}
